import { Modal } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledModal = styled(Modal)(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(3),
  zIndex: 9999,
}));
